import { FORM_OVERRIDE_FORCE_FALSE_VALUE, INJECT_UICORE_FORM_GET_OVERRIDE_PROPS } from "../../../../lib/utils/consts";
import { createVueInheritableContext } from "../../../../lib/utils/vue/vueInheritableContext";
const defaultProps = {
  readonly: false,
  required: false,
  hasSuccessFeedback: false,
  disabled: false
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export const formOverridePropIds = Object.keys(defaultProps);
// 考虑存量 false true时维持原本逻辑   检查overrideProps.xxx是特殊值的时候 拒绝父级继承 直接写入
/** 输入个OverrideProps数组 把key of OverrideProps 进行merge 按照false/undefined 继承后续 返回一个merge完成的对象*/
export function mergeFormOverridesProps(...items) {
  const ans = {
    ...defaultProps
  };
  items.forEach(overrideProps => {
    if (!overrideProps) return;
    const overrideKeys = Object.keys(defaultProps);
    overrideKeys.forEach(overrideKey => {
      const overrideValue = overrideProps[overrideKey];
      if (`${overrideValue}` === FORM_OVERRIDE_FORCE_FALSE_VALUE) {
        ans[overrideKey] = false;
      } else if (!ans[overrideKey]) {
        // 原本的双值继承逻辑子类仅可覆盖父类的false
        ans[overrideKey] = !!overrideValue;
      }
    });
  });
  return ans;
}
const {
  consumer,
  provider
} = createVueInheritableContext(INJECT_UICORE_FORM_GET_OVERRIDE_PROPS, mergeFormOverridesProps);
/**
 * 用法: 父组件mixin provider 子组件mixin consumer
 * 则父组件中的keyof OverrideProps被打包后 会进行一次provide
 * 子组件inject特殊的key之后将代理keyof OverrideProps
 * 对应的值将变成继承逻辑处理后的值
 * */
export { consumer as formOverridePropsConsumer, provider as formOverridePropsProvider };